'use client'

import React from 'react'
import {
  MultiSelector,
  MultiSelectorTrigger,
  MultiSelectorInput,
  MultiSelectorContent,
  MultiSelectorList,
  MultiSelectorItem,
} from '@/components/ui/multi-selector'

// Common spoken languages with their display names
const SPOKEN_LANGUAGES = [
  { id: 'en', name: 'English' },
  { id: 'lt', name: 'Lithuanian' },
  { id: 'de', name: 'German' },
  { id: 'fr', name: 'French' },
  { id: 'es', name: 'Spanish' },
  { id: 'it', name: 'Italian' },
  { id: 'ru', name: 'Russian' },
  { id: 'pl', name: 'Polish' },
  { id: 'lv', name: 'Latvian' },
  { id: 'et', name: 'Estonian' },
  { id: 'fi', name: 'Finnish' },
  { id: 'sv', name: 'Swedish' },
  { id: 'no', name: 'Norwegian' },
  { id: 'da', name: 'Danish' },
  { id: 'nl', name: 'Dutch' },
  { id: 'pt', name: 'Portuguese' },
  { id: 'zh', name: 'Chinese' },
  { id: 'ja', name: 'Japanese' },
  { id: 'ko', name: 'Korean' },
  { id: 'ar', name: 'Arabic' },
  { id: 'hi', name: 'Hindi' },
  { id: 'tr', name: 'Turkish' },
  { id: 'ua', name: 'Ukrainian' },
  { id: 'cs', name: 'Czech' },
  { id: 'sk', name: 'Slovak' },
  { id: 'hu', name: 'Hungarian' },
  { id: 'ro', name: 'Romanian' },
  { id: 'bg', name: 'Bulgarian' },
  { id: 'hr', name: 'Croatian' },
  { id: 'sr', name: 'Serbian' },
  { id: 'sl', name: 'Slovenian' },
]

interface SpokenLanguagesSelectProps {
  value: string[]
  onChange: (languages: string[]) => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

export default function SpokenLanguagesSelect({
  value = [],
  onChange,
  placeholder = 'Select spoken languages...',
  disabled = false,
  className,
}: SpokenLanguagesSelectProps) {
  // Convert string array to MultiSelector format
  const selectedValues = SPOKEN_LANGUAGES.filter(lang =>
    value.includes(lang.id)
  )

  const handleValuesChange = (
    newValues: Array<{ id: string; name: string; image?: string }>
  ) => {
    const languageIds = newValues.map(val => val.id)
    onChange(languageIds)
  }

  return (
    <MultiSelector
      values={selectedValues}
      onValuesChange={handleValuesChange}
      className={className}
    >
      <MultiSelectorTrigger>
        <MultiSelectorInput placeholder={placeholder} />
      </MultiSelectorTrigger>
      <MultiSelectorContent>
        <MultiSelectorList>
          {SPOKEN_LANGUAGES.map(language => (
            <MultiSelectorItem key={language.id} value={language}>
              {language.name}
            </MultiSelectorItem>
          ))}
        </MultiSelectorList>
      </MultiSelectorContent>
    </MultiSelector>
  )
}
